import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarIconComponent } from '../../shared/snack-bar-icon/snack-bar-icon.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarIconService {

  constructor(private snackBar: MatSnackBar) { }
  public openSnackBar(message: string, action: string, snackType?: any) {
    const _snackType: any =
      snackType !== undefined ? snackType : 'Success';

    this.snackBar.openFromComponent(SnackBarIconComponent, {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: { message: message, snackType: _snackType }
    });
  }

}
